import { z } from 'zod';
const approveVolunteersName = 'approveVolunteers';
export const shiftParticipationSchema = z.object({
    shiftParticipantId: z.string().uuid(),
    shiftParticipationId: z.string().uuid(),
    positionId: z.string().uuid(),
});
const approveVolunteersPlatformFunctionParamsSchema = z.object({
    shiftId: z.string().uuid(),
    shiftParticipations: shiftParticipationSchema.array(),
});
export const approveVolunteersFunctionDef = {
    name: approveVolunteersName,
    requestSchema: approveVolunteersPlatformFunctionParamsSchema,
    responseSchema: z.void(),
};
export const approveVolunteersBulkActionType = approveVolunteersName;
const approveVolunteersBulkActionParamsSchema = approveVolunteersPlatformFunctionParamsSchema.merge(z.object({
    totalShiftParticipations: z.number(),
}));
